import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { translate } from 'i18n/jhipster-language';
import { confirmPopup } from 'primereact/confirmpopup';
import { defaultLimit } from 'shared/lib/card-limit-defaults';
import CardLimitsTable from 'shared/ui/card-limits-table';
import CardProductLimitFormDialog from './card-product-limit-form-dialog';
import { isCardProductLimitFormValid } from './card-product-limit.validation';
import { toLimitApiPayload, toLimitFormState } from './card-product-limit.constants';
import { useAccCurrencyOptions } from 'shared/hooks/use-acc-currency-options';
import { useCardLimitsList } from './hooks/use-card-limits-list';
export function CardLimitsTabCore(props) {
    const id = props.scope === 'product' ? props.productId : props.cardId;
    const limitOwner = props.scope === 'product' ? { productId: props.productId } : { cardId: props.cardId };
    const currencyOptions = useAccCurrencyOptions();
    const { limits, loading, updating, updateSuccess, createLimit, updateLimit, deleteLimit, applyListFilters, clearListFilters, } = useCardLimitsList(props.scope, id);
    const [formOpen, setFormOpen] = useState(false);
    const [form, setForm] = useState(() => defaultLimit(limitOwner));
    const [submitted, setSubmitted] = useState(false);
    const [saveDispatched, setSaveDispatched] = useState(false);
    useEffect(() => {
        setForm(defaultLimit(limitOwner));
        setFormOpen(false);
        setSubmitted(false);
        setSaveDispatched(false);
    }, [props.scope, id]);
    useEffect(() => {
        if (!updateSuccess || !formOpen || !submitted || !saveDispatched) {
            return;
        }
        setFormOpen(false);
        setSubmitted(false);
        setSaveDispatched(false);
    }, [updateSuccess, formOpen, submitted, saveDispatched]);
    const openCreate = () => {
        setForm(toLimitFormState(defaultLimit(limitOwner), limitOwner));
        setSubmitted(false);
        setSaveDispatched(false);
        setFormOpen(true);
    };
    const openEdit = (row) => {
        setForm(toLimitFormState(row, limitOwner));
        setSubmitted(false);
        setSaveDispatched(false);
        setFormOpen(true);
    };
    const save = () => {
        setSubmitted(true);
        if (!isCardProductLimitFormValid(form)) {
            return;
        }
        const payload = toLimitApiPayload(form);
        setSaveDispatched(true);
        if (form.id != null) {
            updateLimit(payload);
        }
        else {
            createLimit(props.scope === 'product'
                ? { ...payload, productId: props.productId, cardId: null }
                : { ...payload, cardId: props.cardId, productId: null });
        }
    };
    const onDelete = (row, e) => {
        confirmPopup({
            acceptLabel: translate('entity.action.yes'),
            rejectLabel: translate('entity.action.no'),
            target: e.currentTarget,
            message: translate('entity.delete.title'),
            icon: 'pi pi-exclamation-triangle',
            accept() {
                if (row.id != null) {
                    deleteLimit(row.id);
                }
            },
        });
    };
    const closeForm = () => {
        setFormOpen(false);
        setSubmitted(false);
        setSaveDispatched(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(CardLimitsTable, { limitOwner: limitOwner, limits: limits, loading: loading, showIsOverrideColumn: props.scope === 'card', onCreate: openCreate, onEdit: openEdit, onDelete: onDelete, applyListFilters: applyListFilters, clearListFilters: clearListFilters, className: props.scope === 'card' ? 'mt-5' : undefined }), _jsx(CardProductLimitFormDialog, { visible: formOpen, submitted: submitted, form: form, setForm: setForm, currencyOptions: currencyOptions, updating: updating, onHide: closeForm, onSave: save })] }));
}
